import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import BudgetPersonalizeView from 'src/components/atomic/pages/budgets/personalize/BudgetPersonalizeView';
import BudgetHistoryView from 'src/components/atomic/pages/budgets/history/BudgetHistoryView';
import BudgetSettingsView from 'src/components/atomic/pages/budgets/settings/BudgetSettingsView';
import BudgetIndexView from 'src/components/atomic/pages/budgets/index/BudgetIndexView';
import TransactionsBudgetView from 'src/components/atomic/pages/transactions/view/TransactionsBudgetView';
import TransactionDetailsView from 'src/components/atomic/pages/transactions/details/TransactionDetailsView';
import TransactionsReviewView from '../../atomic/organisms/unified-transactions/TransactionsReviewView';
import ManageRulesView from 'src/components/atomic/pages/transactions/rules/ManageRulesView';

import styles from './budgetJourney.module.scss';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import IneligibleView from 'src/components/atomic/pages/ineligible/IneligibleView';
import SecondaryNavigation from 'src/components/navigation/SecondaryNavigation';
import GlobalHeader from 'src/components/navigation/GlobalHeader';
import SelectDetailedProvider from 'src/components/atomic/layouts/selectDetailedProvider/SelectDetailedProvider';
import { useAppendNativeParam } from 'src/hooks/useAppendNativeParam';

export default function BudgetJourney(): JSX.Element {
    useAppendNativeParam();

    return (
        <SelectDetailedProvider>
            <div className={styles.budgetJourney}>
                <GlobalHeader />
                <Switch>
                    <Route exact path={BudgetPages.INELIGIBLE} component={IneligibleView} />
                    <Route>
                        <SecondaryNavigation />
                        <Switch>
                            <Route exact path={BudgetPages.HOME} component={BudgetIndexView} />
                            <Route exact path={BudgetPages.PERSONALIZE} component={BudgetPersonalizeView} />
                            <Route exact path={BudgetPages.HISTORY} component={BudgetHistoryView} />
                            <Route exact path={BudgetPages.SETTINGS} component={BudgetSettingsView} />
                            <Route exact path={BudgetPages.TRANSACTIONS_REVIEW} component={TransactionsReviewView} />
                            <Route exact path={BudgetPages.TRANSACTIONS} component={TransactionsBudgetView} />
                            <Route exact path={BudgetPages.TRANSACTIONS_RULES} component={ManageRulesView} />
                            <Route exact path={`${BudgetPages.TRANSACTIONS}/:id`} component={TransactionDetailsView} />
                            <Redirect from="*" to={BudgetPages.HOME} /> {/* catch-all redirect route */}
                        </Switch>
                    </Route>
                </Switch>
            </div>
        </SelectDetailedProvider>
    );
}
